import React, { useEffect, useState } from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { Loader2, Stethoscope } from 'lucide-react';
import api, { resolveImageUrl } from '@/lib/api';
import { VerifiedBadge } from '@/components/professional/VerifiedBadge';

const initials = (n = '') => n.split(' ').map((p) => p[0]).join('').slice(0, 2).toUpperCase();

export default function VerifiedProfessionalsPage() {
  const [items, setItems] = useState(null);

  useEffect(() => {
    api.get('/user/professionals/verified').then((r) => setItems(r.data)).catch(() => setItems([]));
  }, []);

  return (
    <div className="max-w-4xl mx-auto space-y-5" data-testid="verified-professionals-page">
      <div>
        <h1 className="text-2xl sm:text-3xl font-bold flex items-center gap-2"><Stethoscope className="h-7 w-7 text-purple-500" />Profissionais verificados</h1>
        <p className="text-sm text-muted-foreground mt-1">Profissionais da comunidade com credenciais validadas pela equipe U-Clean.</p>
      </div>
      {items === null ? <div className="flex justify-center py-16"><Loader2 className="h-6 w-6 animate-spin text-muted-foreground" /></div>
        : items.length === 0 ? <Card><CardContent className="p-8 text-center text-muted-foreground" data-testid="verified-professionals-empty">Ainda não há profissionais verificados públicos.</CardContent></Card>
        : <div className="grid grid-cols-1 md:grid-cols-2 gap-4">{items.map((p) => (
          <Card key={p.user_id} data-testid={`verified-pro-${p.user_id}`}>
            <CardContent className="p-4 sm:p-5 space-y-3">
              <div className="flex items-center gap-3">
                <Avatar className="h-12 w-12"><AvatarImage src={resolveImageUrl(p.avatar_url)} /><AvatarFallback>{initials(p.professional_name)}</AvatarFallback></Avatar>
                <div className="min-w-0 flex-1">
                  <p className="font-semibold break-words">{p.professional_name}</p>
                  <VerifiedBadge show testid="verified-pro-badge" />
                </div>
              </div>
              <p className="text-sm text-muted-foreground">{[p.specialty, p.institution].filter(Boolean).join(' · ')}</p>
              {p.short_cv && <p className="text-sm whitespace-pre-line line-clamp-4">{p.short_cv}</p>}
            </CardContent>
          </Card>
        ))}</div>}
    </div>
  );
}
